// extracted by mini-css-extract-plugin
module.exports = {"text":"free_text__1n63X","unavailableBtnPlan":"free_unavailableBtnPlan__WbtK-"};